//--------------------------------------------------
// imported classes
//--------------------------------------------------
const Common = require('./Common')
const ClassFunc = require('../../util/ClassFunc')

/**
 * The Organization class works as the organization translator.
 */
const tbs_model_to_Organization = function() {
    //--------------------------------------------------
    // super method for the base class
    //--------------------------------------------------
    ClassFunc.super(this, Common, arguments);
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_to_Organization.prototype = {
    // organization manager
    'organization-feature-type-0': '基础版',
    'organization-feature-type-1': '进阶版',
    'check-in-period': '入驻$num$unit',
    'team-list': '球队列表',
    'video-library': '视频库',
    'schedule-table': '赛程表',
    'referee-admin': '裁判管理',
    'staff-admin': '工作人员',
    'asset-library': '素材库',
    'mini-program': '机构小程序',
    'organization-info': '机构信息',
    'account': '账户',
    'go-account': '前往开户',
    'go-account-description': '完成认证，即可报名缴费',
    'go-auth': '前往认证',
    'go-auth-confirm-message': '开户前，请先完成机构认证',
    'video-service': '视频服务',
    'match-insurance': '赛事保险',
    'data-stats': '数据统计',
    'register-transfer': '注册&转会',
    'clothing-customization': '服装定制',
    'derivative-customization': '衍生品定制',
    'game-screen': '比赛大屏',
    'mp-customization': '定制小程序',
    'check-in': '检录&签到',
    'data-export': '数据导出',
    'toolbox': '工具箱',
    // organization entity
    'organization-name-label': '机构名称',
    'organization-name-placeholder': '机构名称',
    'organization-name-required': '请填写机构名称',
    'organization-logo-label': '机构LOGO',
    'organization-logo-placeholder': '建议使用PNG格式，背景透明图片，图片大小400X400 PX',
    'organization-area-required': '请选择城市区域',
    'organization-sport-type-required': '请选择运动类型',
    'organization-contact-label': '联系人',
    'organization-contact-placeholder': '联系人姓名',
    'organization-contact-required': '请填写联系人',
    'organization-position-label': '职位',
    'organization-position-placeholder': '职位名',
    'organization-position-required': '请填写职位',
    'organization-empty-hint': '暂无可选机构，请先新建机构',
    'delete-organization': '删除机构',
    'delete-organization-confirm-message': '确认删除该机构，无法进行还原',
    'delete-organization-placeholder': '请输入完整机构名称',
    'create-organization': '新建机构',
    'history-organization-list': '机构列表',
    // organization authentication
    'organization-authentication': '机构认证',
    'authentication-status': '认证状态',
    'authentication-failed-reason': '失败理由：',
    'authentication-info': '认证信息',
    'authentication-intro': '认证说明',
    'organization-type': '机构类型',
    'organization-type-1': '企业',
    'organization-type-2': '协会/学校/机关',
    'organization-type-3': '个人',
    'organization-type-required': '请选择机构类型',
    'business-licence-pic-label': '营业执照图片',
    'business-licence-pic-required': '请上传营业执照图片',
    'organization-fullname-label': '机构全称',
    'organization-fullname-required': '请输入机构全称',
    'business-licence-code-label': '统一社会信用代码',
    'business-licence-code-required': '请输入统一社会信用代码',
    'business-licence-start-date-label': '执照起始有效期',
    'business-licence-start-date-required': '请选择执照起始有效期日期',
    'business-licence-end-date-label': '执照结束有效期',
    'business-licence-end-date-required': '请选择执照结束有效期日期',
    'credential-pic-label': '登记证书图片',
    'credential-pic-required': '请上传登记证书图片',
    'credential-type': '登记证书类型',
    'credential-type-required': '请选择登记证书类型',
    'credential-type-1': '事业单位法人证书',
    'credential-type-2': '政府机关统一社会信用代码证书',
    'credential-type-3': '社会组织统一社会信用代码证书',
    'credential-type-4': '社会团体法人登记证书',
    'credential-type-5': '民办非企业单位登记证书',
    'credential-code-label': '统一社会信用代码',
    'credential-code-required': '请输入统一社会信用代码',
    'credential-start-date-label': '证书起始有效期',
    'credential-start-date-required': '请选择证书起始有效期日期',
    'credential-end-date-label': '证书结束有效期',
    'credential-end-date-required': '请选择证书结束有效期日期',
    'credential-registration-address-label': '证书登记地址',
    'credential-registration-address-required': '请输入证书登记地址',
    'user-identity-type': '证件类型',
    'identity-card': '身份证',
    'user-fullname-label': '姓名',
    'user-fullname-required': '请输入姓名',
    'user-card-pic-label': '证件照片',
    'user-face-photo-pic-required': '请上传身份证人像面照片',
    'user-national-emblem-pic-required': '请上传身份证国徽面照片',
    'user-identity-code-label': '证件号码',
    'user-identity-code-required': '请输入身份证号',
    'phone-number-label': '联系手机',
    'phone-number-required': '请输入手机号',
    'authentication-intro-line-1': '1、请选择对应机构类型进行认证：',
    'authentication-intro-line-2': '    企业：适用于各类体育赛事公司、活动执行公司等',
    'authentication-intro-line-3': '    协会/学校/机关：适用于各级体育主管部门、体育运动协会、',
    'authentication-intro-line-4': '    各类学校，机关事业单位和其他民办非企业类机构',
    'authentication-intro-line-5': '    个人：仅用于个人日常举办赛事和活动的报名资料收集',
    'authentication-intro-line-6': '2、提交认证资料后，可使用在线报名功能',
}

//--------------------------------------------------
// extends the Common
//--------------------------------------------------
ClassFunc.extend(tbs_model_to_Organization, Common);

module.exports = tbs_model_to_Organization